import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ActivityStatus, StateTypes } from '../../../common/enums';
import { GenericDefaultSelectOption, IGenericDefaultSelectOption, IPagination } from '../../../models/generic';
import { ITicketListingViewModel, ITicketParameter, TicketParameter } from '../../../models/ticket';
import { ServiceBookService } from '../../../services/serviceBook.service';
import { BLOCK_LOADERS, BLOCK_MODULE_NAMESPACE, BLOCK_SET_LOADER_STATE } from '../../../store/block';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../store/service-book';
import { IServiceBookDetails } from '../../../store/service-book/service-book-state.store';
import { TICKET_GET_TICKETS, TICKET_MODULE_NAMESPACE, TICKET_RESET_TICKETS } from '../../../store/ticket';


const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const BlockStore= namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  name:'ServiceBookTickets',
  components: {
    'list-item': async () => import('@/containers/ticket/components/ticket-list-item/TicketListItem.vue'),
    'ticket-list-loader': async () => import('../../ticket/loaders/ticket-list-loader/TicketListLoader.vue'),
  }
})
class ServiceBookTickets extends Vue {


  @ServiceBookStore.Getter isLoading: boolean;
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => void

  @TicketStore.Getter pagination: IPagination;
  @TicketStore.Getter activityStatus: ActivityStatus;
  @TicketStore.Getter ticketViewModels: ITicketListingViewModel[];

  @TicketStore.Action(TICKET_GET_TICKETS)
  storeGetTickets: (payload: { param: ITicketParameter, merge: boolean }) => Promise<ITicketListingViewModel[]>;

  @TicketStore.Mutation(TICKET_RESET_TICKETS)
  storeResetTickets: () => void;

  @BlockStore.Mutation(BLOCK_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean }) => void

  dtSearchParameter: ITicketParameter;

  constructor() {
    super();
    this.dtSearchParameter = new TicketParameter({
      state: [
        StateTypes.Open,
        StateTypes.InProgress,
        StateTypes.ReOpen
      ],
      apartment: []
    });
  }

  beforeMount()
  {
    const id = this.$route.params.id
    this.storeGetServiceBook(id)
  }

  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get coSearchParameter() {
    //this.dtSearchParameter.block = [Number(this.$route.params.id)]
    this.dtSearchParameter.apartment = Number(this.currentServiceBook.apartment.id)
    return {
      param: { ...this.dtSearchParameter },
      merge: false
    }
  }

  get fkTicketState(): string[] | number[] {
    return this.dtSearchParameter.state
  }
  set fkTicketState(value: string[] | number[]) {
    this.dtSearchParameter.state = value;
  }

  get coStates(): IGenericDefaultSelectOption<string>[] {
    return [
      StateTypes.Open,
      StateTypes.InProgress,
      StateTypes.ReOpen,
      StateTypes.Close
    ].map(type => new GenericDefaultSelectOption<string>(this.$t(this.lblSetting.lblState[type]).toString(), type));
  }

  setTicketLoaderState(value: boolean){
    this.storeSetLoaderState({ key: BLOCK_LOADERS.TICKETS, value })
  }


}

export default ServiceBookTickets;



// WEBPACK FOOTER //
// ./src/containers/service-book/tickets_UNUSED/index.ts